import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import type { Promisable } from "type-fest";

import type { Assessment } from "@thalamos/haven-common";

import { AssessmentActivity } from "../../components/AssessmentActivity/AssessmentActivity.js";

/** Every act on one assessment, over whichever of its screens is open. */
export const AssessmentActivityDialog = ({
  assessment,
  onClose,
}: {
  assessment: Assessment;
  onClose: () => Promisable<void>;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  // The whole screen on a phone, so the log gets the width it needs.
  const narrow = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open
      onClose={() => void onClose()}
      fullWidth
      maxWidth="sm"
      fullScreen={narrow}
    >
      <DialogContent>
        <AssessmentActivity assessment={assessment} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => void onClose()}>
          {t("common.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
